import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, Mail } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const detail = (err) => {
  const d = err.response?.data?.detail;
  return typeof d === "string" ? d : Array.isArray(d) ? `Please check ${d[0]?.loc?.slice(-1)[0]}: ${d[0]?.msg}` : "Something went wrong. Please try again.";
};

export function SupportForm() {
  const [form, setForm] = useState({ name: "", email: "", message: "", website: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const r = await axios.post(`${API}/support`, form);
      setDone(r.data);
    } catch (err) {
      setError(detail(err));
    } finally {
      setBusy(false);
    }
  };
  if (done)
    return (
      <div className="request-done" data-testid="support-success">
        <CheckCircle2 size={30} />
        <h2>Message received.</h2>
        <p data-testid="support-reference">Reference {done.message_id}</p>
        <p>
          {done.notified ? "Our team has been notified and will reply to " : "Your message is saved and our team will reply to "}
          <b>{form.email}</b>.
        </p>
        <button className="btn btn-outline" onClick={() => { setDone(null); setForm({ ...form, message: "" }); }} data-testid="support-new-message">
          Send another message
        </button>
      </div>
    );
  return (
    <form className="request-form support-form" onSubmit={submit} data-testid="support-form">
      <label>
        Your name *
        <input required minLength={2} maxLength={100} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="support-name" />
      </label>
      <label>
        Email *
        <input required type="email" maxLength={120} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="support-email" />
      </label>
      <label className="wide">
        How can we help? *
        <textarea required minLength={10} maxLength={3000} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Tell us about your order, fitment question or issue" data-testid="support-message" />
      </label>
      <input className="hp-field" tabIndex={-1} autoComplete="off" aria-hidden="true" name="website" value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} />
      {error && <p className="form-error wide" data-testid="support-error">{error}</p>}
      <button className="btn btn-red" disabled={busy} data-testid="support-submit">
        {busy ? "Sending…" : "Send message"} <ArrowRight size={16} />
      </button>
    </form>
  );
}

export function SupportSection() {
  return (
    <section className="support-section" id="support" data-testid="support-section">
      <div className="request-intro">
        <p className="eyebrow red">SUPPORT / EMAIL</p>
        <h2>
          Talk to
          <br />
          <i>a human.</i>
        </h2>
        <p>Order questions, fitment advice or an issue with a delivery — send us a message and we’ll reply by email.</p>
        <p className="support-links">
          <Mail size={15} /> Already ordered? <Link to="/track-order" data-testid="support-track-link">Track your order</Link>
        </p>
      </div>
      <SupportForm />
    </section>
  );
}

export default function SupportPage() {
  return (
    <main className="support-page">
      <SupportSection />
    </main>
  );
}
